import React, { useEffect, createContext, useState } from "react";
import { useSelector } from "react-redux";
import { showToast } from "services/utils/Status";
import sessionHandling from "services/utils/notificationUtils";
import { defaultAllSelection } from "services/constants";

export const ProjectReportContext = createContext({});

export const ProRepContextProvider = ({ children }) => {
  const requestCompanyId = useSelector((state) => state.tokenReducer.topbarCompanyId);
  const { domain, token, userDetails } = useSelector(
    (state) => state.tokenReducer
  );

  const [allUsers, setAllUsers] = useState([]);

  useEffect(() => {
    const fetchAllUsers = async () => {
      try {
        const response = await fetch(`${domain}user_with_avatar/ ?company_id=${requestCompanyId}`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `token ${token}`,
          },
        });
        const res = await response.json();
        if (response.ok) {
          const AllUsersData = res.map((obj) => ({
            ...obj,
            label: obj?.username,
            image_url: obj?.image_url,
          }));
          const allUsername = {
            label: "All",
            user_id: defaultAllSelection,
            username: "All",
          };
          setAllUsers([allUsername, ...AllUsersData]);
        } else if (response.status === 409) {
          sessionHandling();
        } else {
          throw new Error('REQUEST_FAILED');
        }
      } catch (error) {
        console.error('[Projectcontext] operation failed:', error);
        showToast("error", "Couldn't load the project report. Please try again.");
      }
    };
    fetchAllUsers();
  }, [domain, token, requestCompanyId]);

  return (
    <ProjectReportContext.Provider
      value={{
        token,
        domain,
        allUsers,
        userDetails,
      }}
    >
      {children}
    </ProjectReportContext.Provider>
  );
};
